export default __webpack_public_path__ + "static/media/HomepageBG.692681e5.gif";